import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Button, Checkbox, Modal, message } from "antd";
import { IMG_DEFAULT, MyIcon } from "../../common/baseConfig";
import LoginModal from "../common/LoginModal"
const confirm = Modal.confirm;
const CheckboxGroup = Checkbox.Group;
export class ShoppingCart extends Component {
  state = {
    checkAll: false,
    checkedList: [],
    visible: false,
  }
  static propTypes = {
    pay: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    let studentinfo = localStorage.getItem("studentinfo");
    let handleData = [];
    if (studentinfo) {
      let ShoppingData = JSON.parse(localStorage.getItem('shoppingCartData'));
      if (ShoppingData) {
        ShoppingData.map(item => {
          //add return
          return handleData.push({ BusId: item.ID, BusType: item.BusType })
        })
        this.props.actions.fetchNoLoginInputToShopcar({ model: handleData }).then(res => {
          if (res.data.SuccessResponse) {
            this.props.actions.fetchGetShoppingCar();
            localStorage.removeItem('shoppingCartData')
          }
        })
      } else {
        this.props.actions.fetchGetShoppingCar();
      }
    }
  }
  delConfirm(data) {
    if (this.state.checkedList.length === 0) {
      message.warn("您还未选中任何商品");
      return;
    }
    let title = `确认要删除这${this.state.checkedList.length}种商品吗？`
    confirm({
      title: title,
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        if (!localStorage.getItem('studentinfo')) {
          let { checkedList } = this.state;
          let shoppingCartData = JSON.parse(localStorage.getItem('shoppingCartData'));
          let handleData = [];
          checkedList.map(item => {
            //add return
            return handleData.push(shoppingCartData[item]);
          })
          handleData.map(item => {
            //Expected to return a value at the end of arrow function ==> add return
            return shoppingCartData.map((_item, index) => {
              if (item.BusId === _item.BusId) {
                return shoppingCartData.splice(index, 1)
              } else {
                return '';
              }
            })
          })
          localStorage.setItem('shoppingCartData', JSON.stringify(shoppingCartData))
          this.setState({
            checkedList: [],
            checkAll: false,
          })
          this.props.actions.delShoppingSuccess();
          message.success('删除成功');
        } else {
          let params = [];
          for (let i = 0; i < data.length; i++) {
            const ele = data[i];
            if (this.state.checkedList.indexOf(i) !== -1) {
              params.push(ele.CarShopID);
            }
          }
          this.props.actions.fetchMoveOutCarts(params).then(res => {
            if (res.SuccessResponse) {
              this.props.actions.fetchGetShoppingCar().then(res => {
                if (res.SuccessResponse) {
                  this.setState({
                    checkedList: [],
                    checkAll: false,
                  })
                }
              });
            }
          })
        }
      }
    })
  }
  onCancel() {
    this.setState({
      visible: false,
    })
  }
  submitCart(data) {
    let payload = [];
    let studentinfo = localStorage.getItem('studentinfo');
    const { checkedList } = this.state;
    if (checkedList.length === 0) {
      message.warn('至少选择一个商品结算');
      return;
    }
    if (studentinfo) {
      checkedList.forEach(key => {
        payload.push({ CourseId: data[key].ID, BusType: data[key].BusType });
      })
      this.props.actions.fetchAddOrderFromCarts(payload).then(res => {
        if (res.SuccessResponse) {
          let params = {};
          params.OrderId = res.Data.OrderId;
          params.Money = res.Data.Price;
          params.OrderName = "课程支付";
          params.IsStudent = 1;
          this.props.actions.fetchUnifiedCreateOrder(params).then(res => {
            if (res.SuccessResponse) {
              this.props.actions.clearCartCount();
              this.props.history.push(`/paytype/${res.Data.OrderId}`);
            }
          })
        }
      })
    } else {
      this.setState({ visible: true })
    }
  }
  render() {
    const { fetchGetShoppingCarTotal, fetchGetShoppingCarSuccess } = this.props.common;
    const { MaxCouponData } = this.props.pay;
    const { visible } = this.state;
    let arr = [], num = 0;
    if (fetchGetShoppingCarSuccess && fetchGetShoppingCarSuccess.length) {
      fetchGetShoppingCarSuccess.forEach((item, index) => {
        if (this.state.checkedList.indexOf(index) !== -1) {
          num += parseFloat(item.PreferentialPrice);
        }
      });
      fetchGetShoppingCarSuccess.forEach((item, index) => {
        arr.push(index);
      })
    }
    const onChange = (checkedList) => {
      let arrList = [];
      checkedList.sort();
      checkedList.map(item => {
        let items = fetchGetShoppingCarSuccess[item];
        arrList.push({
          CourseId: items.ID,
          BusType: items.BusType,
          Price: items.PreferentialPrice
        })

        //Expected to return a value in arrow function
        return item;
      })
      this.props.actions.fetchGetMaxCouponPrice(arrList);
      this.setState({
        checkedList,
        checkAll: checkedList.length === arr.length,
      });
    }
    const onCheckAllChange = (e) => {
      let arrList = [];
      arr.map(item => {
        let items = fetchGetShoppingCarSuccess[item];
        arrList.push({
          CourseId: items.ID,
          BusType: items.BusType,
          Price: items.PreferentialPrice
        })

        //Expected to return a value in arrow function
        return item;
      })
      this.props.actions.fetchGetMaxCouponPrice(e.target.checked ? arrList : []);
      this.setState({
        checkedList: e.target.checked ? arr : [],
        checkAll: e.target.checked,
      });
    }

    return (
      <div className="pay-shopping-cart">
        <div className="banner">
          <h1>我的购物车</h1>
        </div>
        <div className="cart-detail">
          <h2>
            <p>我的购物车</p>
            <p>共{fetchGetShoppingCarTotal}门 已选择{this.state.checkedList.length}门</p>
            <p className="del" onClick={() => this.delConfirm(fetchGetShoppingCarSuccess)}><MyIcon type="iconshanchu1" /></p>
          </h2>
          {fetchGetShoppingCarTotal > 0 && <div className="carts">
            <CheckboxGroup
              style={{ width: "100%" }}
              value={this.state.checkedList}
              onChange={onChange}
            >
              {
                fetchGetShoppingCarSuccess && fetchGetShoppingCarSuccess.map((item, index) => (
                  <div className="cart-item" key={index}>
                    <h3>
                      <Checkbox value={index} ref={`check${index}`} />
                      <img src={item.CoverPath || IMG_DEFAULT} alt="" />
                      <div>
                        <p>{item.Name}</p>
                        <p>授课讲师：{item.TeacherDetail_Name || '匿名'}</p>
                      </div>
                    </h3>
                    <div className="right">
                      <p>¥{item.PreferentialPrice.toFixed(2)}</p>
                    </div>
                  </div>
                ))
              }
            </CheckboxGroup>
            <div className="carts-footer">
              <Checkbox
                checked={this.state.checkAll}
                onChange={onCheckAllChange}
              >全选</Checkbox>
              <div>
                <p className="p1">共{this.state.checkedList.length}件商品</p>
                {this.state.checkedList.length > 0 && <p className="p1">商品合计：{num.toFixed(2)}</p>}
                {this.state.checkedList.length > 0 && <p className="p1">{MaxCouponData > 0 ? '优惠：' + MaxCouponData.toFixed(2) : ''}</p>}
                <p className="p2">应付总额：</p>
                <p className="p3">{MaxCouponData > 0 ? (num - MaxCouponData).toFixed(2) : num.toFixed(2)}</p>
                <Button type="theme" className="submitCart" onClick={this.submitCart.bind(this, fetchGetShoppingCarSuccess)}>去结算</Button>
              </div>
            </div>
          </div>}
          {
            fetchGetShoppingCarTotal === 0 && <div className="noneData">
              <img src={require("../../images/noneOrder.png")} alt="" />
              <p>您的购物车空空如也~选课走起~</p>
              <Button type="theme2"
                onClick={() => this.props.history.push('/courseList')}
              >马上去选课</Button>
            </div>
          }
        </div>
        <LoginModal visible={visible} onCancel={this.onCancel.bind(this)} />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pay: state.pay,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShoppingCart);



// WEBPACK FOOTER //
// ./src/features/pay/ShoppingCart.js